import React, { useState } from "react";
import PropTypes from "prop-types";
import { uuid } from "Utils/utils";

const ServiceCard = ({ item, stepNumber }) => {
	const { title, subtitle, items, action } = item;
	const [isOpen, setIsOpen] = useState(false);

	return (
		<>
			<div className="">
				<div className="mb-3">
					<span className="fs-2 fw-500 mt-0">{title}</span>
					<br />
					<span className="fs-5 text-sleet mt-0">Stage {stepNumber}</span>
					<br />
					{/* <span className="text-success"> <span data-typed=""></span><span className="typed-cursor" aria-hidden="true">|</span></span> */}
				</div>
				<p className="fs-4 text-light my-2">{subtitle}</p>
				<div className="row row-cols-lg-2 row-cols-1 mb-3">
					<div className="col">
						{items &&
							items.map((item, index) => (
								<div className="d-flex" key={uuid()}>
									<div className="me-4">
										<i className="mdi mdi-check-circle  mdi-18px" />
									</div>
									<p className="text-capitalize">{item}</p>
								</div>
							))}
					</div>
				</div>

				<div className="">
					<a href={action.url} className="fs-5">
						{action.text}
						<i className="mdi mdi-arrow-right ml-1" />
					</a>
				</div>
			</div>
		</>
	);
};

ServiceCard.propTypes = {
	item: PropTypes.object.isRequired,
	stepNumber: PropTypes.number.isRequired,
};

export default ServiceCard;
